// extracted by mini-css-extract-plugin
export default {"dateInput":"styles_dateInput__Es60W","icon":"styles_icon__eYnbf"};